var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section section-shaped section-lg my-0"},[_c('div',{staticClass:"shape shape-style-1 bg-gradient-default"}),_c('register-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }